module.exports = __webpack_public_path__ + "static/media/buffet21.c9472495.jpg";